var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conditions-label"},[_c('a',{class:_vm.color,on:{"click":function($event){$event.preventDefault();return _vm.showConditions.apply(null, arguments)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-information-outline")]),_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }